import React, { useEffect, useState } from 'react';
import UserTable from './UserTable';
import UserFormModal from './UserFormModal';
import api from '../../api/axios';

const UsuariosView = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editingUser, setEditingUser] = useState(null);

  const business = JSON.parse(localStorage.getItem('business'));
  const business_id = business?.id;

  const fetchUsuarios = async () => {
    try {
      const res = await api.get(`/users/staff?business_id=${business_id}`);
      setUsuarios(res.data);
    } catch (err) {
      console.error('Error al traer usuarios:', err);
    }
  };

  const handleEdit = user => {
    setEditingUser(user);
    setModalOpen(true);
  };

  const handleDelete = async id => {
    if (!window.confirm('¿Estás seguro de eliminar este usuario?')) return;
    try {
      await api.delete(`users/staff/${id}`);
      fetchUsuarios();
    } catch (err) {
      console.error('Error al eliminar usuario:', err);
    }
  };

  useEffect(() => {
    fetchUsuarios();
  }, []);

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3>Gestión de Usuarios</h3>
        <button className="btn btn-primary" onClick={() => { setEditingUser(null); setModalOpen(true); }}>
          + Nuevo Usuario
        </button>
      </div>
      <UserTable usuarios={usuarios} onEdit={handleEdit} onDelete={handleDelete} />
      <UserFormModal
        show={modalOpen}
        onHide={() => setModalOpen(false)}
        onCreated={fetchUsuarios}
        initialData={editingUser}
      />
    </div>
  );
};

export default UsuariosView;
